/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AuditInputs */

const en_nav_audit = /** @type {(inputs: Nav_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit`)
};

const es_nav_audit = /** @type {(inputs: Nav_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditoria`)
};

/**
* | output |
* | --- |
* | "Audit" |
*
* @param {Nav_AuditInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_audit = /** @type {((inputs?: Nav_AuditInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AuditInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_audit(inputs)
	return es_nav_audit(inputs)
});